export type SalesRouteLabelKey = 'closedDeals' | 'acceptedProposals'

export type SalesNavRoute = {
  href: string
  labelKey: SalesRouteLabelKey
  matchNested?: boolean
}

export const SALES_NAV_ROUTES: SalesNavRoute[] = [
  { href: '/financial/sales', labelKey: 'closedDeals', matchNested: true },
  { href: '/proposals', labelKey: 'acceptedProposals', matchNested: true },
]
